import React, { Component } from 'react';
import moment from 'moment';
import _ from 'lodash';
import { db } from '../firebase';
import axios from 'axios';
import StockCard from '../components/stock-card.js'
 

export default class Positions extends Component {

    constructor() {
        super();
        this.state = {
            positions: [],
            search_kwd: ''
        }
        this.onPositonSelected = this.onPositonSelected.bind(this);
        this.onKwdChanged = this.onKwdChanged.bind(this);
    }

    onKwdChanged(kwd) {

        this.setState({
            search_kwd: kwd
        })
    }

    onPositonSelected(symbol) {

        this.setState({

            selected_position: symbol
        });
    }

    toggleScreenMode() {

        this.setState({
            full_screen: !this.state.full_screen
        });
    };

    async componentDidMount() {

        let data = await db.getOpenPositions();
        let items = data.map(a => {

            a.unrealized_gains = 0;
            return a;
        });
        this.getLastestPrices(items);
        this.setState({
            selected_position: items[0].symbol,
            positions: items,
            position_detail: null
        });
    }


    async  getLastestPrices(items) {

        let prices = await axios.get('https://api.iextrading.com/1.0/stock/market/batch?types=price&symbols=' + items.map(a => a.symbol).join(","));
        if (prices && prices.data) {

            this.setState({

                positions: this.state.positions.map(a => {

                    a.last_price = prices.data[a.symbol] ? prices.data[a.symbol].price : 0;
                    a.unrealized_gains = a.last_price > 0 ? ((a.last_price - a.price) * a.quantity) : a.quantity * a.price * -1;
                    return a;
                })
            })
        }
    }

    render() {

        let search_kwd = this.state.search_kwd.toLowerCase().trim();
        return (

            <div className="ss-container-stacked ss-page">
                <nav className="navbar is-transparent ss-fixed-row" style={{ height: "72px", borderBottom: "1px solid #dbdbdb" }}>
                    <div class="navbar-brand">
                        <a class="navbar-item">
                            <img src="https://www.iconexperience.com/_img/g_collection_png/standard/512x512/spreadsheet.png" />
                        </a>
                    </div>
                    <div className="navbar-start">
                        <div className="navbar-item">
                            <div>
                                <p className="title is-4">Positions</p>
                            </div>
                        </div>
                    </div>
                    <div class="navbar-end">
                        <div class="navbar-item">
                            <p className="control has-icons-left">
                                <input className="input is-large is-shadowless" type="text" placeholder="Search" style={{ border: 'none' }} onChange={(e) => this.onKwdChanged(e.target.value)} />
                                <span className="icon is-left">
                                    <i className="fa fa-search"></i>
                                </span>
                            </p>
                        </div>
                    </div>
                </nav>
                <div className="section ss-fluid-row">
                    <div style={{ justifyContent: "center", flexWrap: "wrap", display: "flex" }}>
                        {this.state.positions != null && this.state.positions.length > 0 &&

                            this.state.positions.map(a => {

                                if (search_kwd && search_kwd.length) {

                                    if (a.symbol.toLowerCase().indexOf(search_kwd) < 0) {

                                        return;
                                    }
                                }

                                return <div style={{ margin: "12px" }}><StockCard symbol={a.symbol} /> </div>
                            })
                        }
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/containers/positions.js